import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggedInUser, UserCourseProgressWithModules } from 'src/app/models';
import { AuthService } from 'src/app/services/auth.service';
import { CoursesService } from 'src/app/services/courses.service';

@Component({
  selector: 'app-fair-housing-education',
  templateUrl: './fair-housing-education.component.html',
  styleUrls: ['./fair-housing-education.component.css']
})
export class FairHousingEducationComponent implements OnInit {

  constructor(private coursesService: CoursesService, private auth: AuthService, private router: Router, private route: ActivatedRoute) { }

  user!: LoggedInUser;
  progress: number = 0;
  outerColor: string = '';
  innerColor: string = '';

  get course() { return this.coursesService.currentCourse as UserCourseProgressWithModules; }
  get modules() { return this.course.modules; }

  ngOnInit(): void {
    this.user = this.auth.user || {};

    this.coursesService.setCurrentCourseBy('Fair Housing Education');

    // Calculate the progress of the course and assign wheel colors
    this.progress = this.course.courseID !== 'RentWise' ? this.course.fheProgress || 0 : this.course.rentwiseProgress || 0;

    // Low progress
    if (this.progress <= 20) {
      this.outerColor = '#FC051A';
      this.innerColor = '#f57687';
    }

    // Medium progress
    if (this.progress > 20 && this.progress < 60) {
      this.outerColor = '#FFEA00';
      this.innerColor = '#FFFF8F';
    }

    // High progress
    if (this.progress >= 60) {
      this.outerColor = '#008000';
      this.innerColor = '#50C878';
    }
  }

  // Continue course button
  continueCourse() {

    // Course not complete, go to last module
    if (this.course.furthestModuleID < this.modules.length)
      this.router.navigate(['./m', this.course.furthestModuleID + 1], { relativeTo: this.route });

    // Course complete, go to certificate
    if (this.course.furthestModuleID >= this.modules.length)
      this.router.navigate([`./properties`], { relativeTo: this.route });
  }

}
